import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { AppConfig } from 'src/app/app.config';
@Component({
  selector: 'app-sopIndividualOverview-evaluation',
  templateUrl: './sopIndividualOverview.component.html',
  styleUrls: ['./sopIndividualOverview.component.css']
})
export class SopIndividualOverviewComponent implements OnInit {

  constructor(private router: Router, public config: AppConfig,private _location: Location) { }

  ngOnInit() {
  }

  onChildData(value: any) {
    if(value.value) {
      this.config.filterDetails = value.value;
    } else {
      this.config.filterDetails = [];
    }
    switch (value.key) {
      case 'back':this.router.navigate(['evaluation/observeSOP/statistical']);  break; // this._location.back();
      case 'processCompliance': this.router.navigate(['evaluation/observeSOP/processCompliance']);    break;
      case 'comments': this.router.navigate(['evaluation/observeSOP/sopComments']);    break;
      case 'individualData': this.router.navigate(['evaluation/observeSOP/sopIndividualOverview']);    break;
      case 'frequencyDistribution': this.router.navigate(['evaluation/observeSOP/frequencyDistribution']);    break;
      default: this.router.navigate(['evaluation/observeSOP/subStepCompliance']);    break;
    }

  }
}
